import type { FormFieldProps } from 'comp/screenBuilder/comp/formBuilder/types/formPropsTypes';
import React, { useContext } from 'react';
import styled from 'styled-components/macro';
import { Form, Checkbox as AntdCheckbox } from 'antd';
import { FormattedMessage } from 'react-intl';
import FormFieldContext from '../../context';

function CheckboxPreview({ field, formFieldName, removeFormItemLabel }: FormFieldProps): JSX.Element {
  const { formItem } = field;
  const { label, ...formItemProps } = formItem;
  const formFieldContext = useContext(FormFieldContext);

  // Check if this is the isPaid field by checking if "isPaid" is in the formFieldName array
  const isIsPaidField = Array.isArray(formFieldName) && formFieldName.includes('isPaid');
  const message = isIsPaidField ? formFieldContext.isPaid?.message : undefined;

  return (
    <Root>
      <StyledFormItem
        {...formItemProps}
        name={formFieldName}
        className={message ? 'checkbox-with-message' : undefined}
        extra={message ? <MessageContainer>{message}</MessageContainer> : undefined}
      >
        <AntdCheckbox disabled>{!removeFormItemLabel && label && <FormattedMessage {...label} />}</AntdCheckbox>
      </StyledFormItem>
    </Root>
  );
}

export default CheckboxPreview;

const Root = styled.div`
  .ant-checkbox-disabled + span {
    color: initial;
  }
`;

// Style the Form.Item to display checkbox and message inline
const StyledFormItem = styled(Form.Item)`
  &.checkbox-with-message {
    .ant-form-item-control {
      display: -webkit-box;
      gap: 8px;
    }

    .ant-form-item-extra {
      margin-top: 0;
      margin-left: 8px;
    }
  }
`;

const MessageContainer = styled.div`
  background-color: #f5f5f5;
  color: #000000;
  padding: 4px 8px;
  border-radius: 4px;
  display: inline-block;
  width: max-content;
`;
